import Leasing from "./Leasing";

export default Leasing;
